import { createAsyncThunk } from "@reduxjs/toolkit";
import { doc, getDoc, getDocs, query, where } from "firebase/firestore";
import { firebaseAuth, pokemonListRef } from "../../utils/firebaseConfig";
import { RootState } from "../store";
import { userPokemonsType } from "../../utils/types";
import { loadLocalList, mergeListsById } from "../../utils/listStorage";

export const getUserPokemons = createAsyncThunk(
  "pokemon/userList",
  async (_, { getState }) => {
    try {
      const {
        app: { userInfo },
      } = getState() as RootState;
      const uid = firebaseAuth.currentUser?.uid;
      if (!userInfo?.email) return [];

      let remote: userPokemonsType[] = [];

      // Preferred: deterministic doc keyed by uid
      if (uid) {
        const snap = await getDoc(doc(pokemonListRef, uid));
        if (snap.exists()) {
          remote = (snap.data().pokemon ?? []) as userPokemonsType[];
        }
      }

      // Fallback for legacy docs created with auto-id
      if (remote.length === 0) {
        const legacy = await getDocs(
          query(pokemonListRef, where("email", "==", userInfo.email))
        );
        legacy.docs.forEach((d) => {
          const list = (d.data().pokemon ?? []) as userPokemonsType[];
          remote.push(...list);
        });
      }

      // Merge with whatever the user added locally before signing in
      // (or in a previous session that didn't get to flush).
      const local = loadLocalList();
      return mergeListsById(remote, local);
    } catch (err) {
      console.error(err);
      throw err;
    }
  }
);

export default getUserPokemons;
